/**
 * localStorage 统一封装
 * 提供类型安全、错误处理的存储操作
 */

/**
 * 存储键名常量
 */
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER_INFO: 'userInfo',
  USER_ID: 'userId',
  USERNAME: 'username',
  NICK_NAME: 'nickName',
  AVATAR: 'avatar',
  ROLE_TYPE: 'roleType',
  PHONE: 'phone',
  EMAIL: 'email',
  STATUS: 'status',
  EMP_NAME: 'empName',
  REMEMBERED_ACCOUNT: 'rememberedAccount',
  REMEMBERED_PASSWORD: 'rememberedPassword'
}

/**
 * 获取存储值
 * @param {string} key 键名
 * @param {*} defaultValue 默认值
 * @returns {*} 存储的值或默认值
 */
export function getStorage(key, defaultValue = null) {
  try {
    const value = localStorage.getItem(key)
    if (value === null) return defaultValue
    // 尝试解析JSON
    try {
      return JSON.parse(value)
    } catch (e) {
      // 如果不是JSON，返回原始字符串
      return value
    }
  } catch (error) {
    console.error(`获取localStorage失败 [${key}]:`, error)
    return defaultValue
  }
}

/**
 * 设置存储值
 * @param {string} key 键名
 * @param {*} value 值（会自动序列化为JSON）
 * @returns {boolean} 是否成功
 */
export function setStorage(key, value) {
  try {
    if (value === null || value === undefined) {
      localStorage.removeItem(key)
      return true
    }
    // 如果是字符串，直接存储；否则序列化为JSON
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value)
    localStorage.setItem(key, stringValue)
    return true
  } catch (error) {
    console.error(`设置localStorage失败 [${key}]:`, error)
    return false
  }
}

/**
 * 移除存储值
 * @param {string} key 键名
 * @returns {boolean} 是否成功
 */
export function removeStorage(key) {
  try {
    localStorage.removeItem(key)
    return true
  } catch (error) {
    console.error(`移除localStorage失败 [${key}]:`, error)
    return false
  }
}

/**
 * 批量移除存储值
 * @param {string[]} keys 键名数组
 * @returns {boolean} 是否全部成功
 */
export function removeStorageBatch(keys) {
  let allSuccess = true
  keys.forEach(key => {
    if (!removeStorage(key)) {
      allSuccess = false
    }
  })
  return allSuccess
}

/**
 * 清除所有存储
 * @returns {boolean} 是否成功
 */
export function clearStorage() {
  try {
    localStorage.clear()
    return true
  } catch (error) {
    console.error('清除localStorage失败:', error)
    return false
  }
}

/**
 * 清除用户相关存储
 * @returns {boolean} 是否成功
 */
export function clearUserStorage() {
  const userKeys = [
    STORAGE_KEYS.TOKEN,
    STORAGE_KEYS.USER_INFO,
    STORAGE_KEYS.USER_ID,
    STORAGE_KEYS.USERNAME,
    STORAGE_KEYS.NICK_NAME,
    STORAGE_KEYS.AVATAR,
    STORAGE_KEYS.ROLE_TYPE,
    STORAGE_KEYS.PHONE,
    STORAGE_KEYS.EMAIL,
    STORAGE_KEYS.STATUS,
    STORAGE_KEYS.EMP_NAME
  ]
  return removeStorageBatch(userKeys)
}

/**
 * 检查存储是否存在
 * @param {string} key 键名
 * @returns {boolean} 是否存在
 */
export function hasStorage(key) {
  try {
    return localStorage.getItem(key) !== null
  } catch (error) {
    console.error(`检查localStorage失败 [${key}]:`, error)
    return false
  }
}

